export const FIN_BORINGLOAD = "FIN_BORINGLOAD";
export const CHANGE_REGNUM = "CHANGE_REGNUM";
export const ADD_DS = "ADD_DS";
export const CHANGE_DS = "CHANGE_DS";
export const CHANGE_ALLDS = "CHANGE_ALLDS";
export const CHANGE_BORDS = "CHANGE_BORDS";
export const DEL_DS = "DEL_DS";
export const SET_DS = "SET_DS";
export const CHANGE_SELROW = "CHANGE_SELROW";
export const ISDEL = "ISDEL";
export const CHANGE_LISTCAT = "CHANGE_LISTCAT";
export const CHANGE_SHOWCHK = "CHANGE_SHOWCHK";
export const CHANGE_USECHK = "CHANGE_USECHK";
//Cat
export const ADD_CAT = "ADD_CAT";
export const DEL_CAT = "DEL_CAT";
export const CHANGE_CATNAME = "CHANGE_CATNAME";
export const CHANGE_CATSELROW = "CHANGE_CATSELROW";
//Main
export const CHANGE_NAME = "CHANGE_NAME";
export const CHANGE_CAT = "CHANGE_CAT";
export const CHANGE_GEOINFO = "CHANGE_GEOINFO";
export const CHANGE_COORDSYSTEM = "CHANGE_COORDSYSTEM";
export const CHANGE_COLOR = "CHANGE_COLOR";
export const CHANGE_TAB = "CHANGE_TAB";
export const ISOK = "ISOK";
export const ISDRAW = "ISDRAW";
//Csv
export const CHANGE_FILE = "CHANGE_FILE";
export const CHANGE_XATTR = "CHANGE_XATTR";
export const CHANGE_YATTR = "CHANGE_YATTR";
export const CHANGE_DEPTHKRDO = "CHANGE_DEPTHKRDO";
export const CHANGE_ZATTR = "CHANGE_ZATTR";
export const CHANGE_GEO = "CHANGE_GEO";
export const CHANGE_ID = "CHANGE_ID";
export const CHANGE_GLCHK = "CHANGE_GLCHK";
export const CHANGE_GL = "CHANGE_GL";
export const CHANGE_WLCHK = "CHANGE_WLCHK";
export const CHANGE_WL = "CHANGE_WL";
export const CHANGE_HEADERNUM = "CHANGE_HEADERNUM";
export const CHANGE_FIELDNAMECHK = "CHANGE_FIELDNAMECHK";
export const CHANGE_CSVDATA = "CHANGE_CSVDATA";
export const CHANGE_NEWDATA = "CHANGE_NEWDATA";
export const CHANGE_FORMDATA = "CHANGE_FORMDATA";
export const CHANGE_USERBORINGDATA = "CHANGE_USERBORINGDATA";
//User
export const ADD_POINT = "ADD_POINT";
export const DEL_POINT = "DEL_POINT";
export const CHANGE_SELROWP = "CHANGE_SELROWP";
export const IS_DELP = "IS_DELP";
export const CHANGE_FIELD = "CHANGE_FIELD";
export const CHANGE_NEWDS = "CHANGE_NEWDS";
export const ADD_LASTGEO = "ADD_LASTGEO";
//topBtnのボーリングカラー
export const CHANGE_BCOLOR = "CHANGE_BCOLOR";
export const CHANGE_EXVARCAT = "CHANGE_EXVARCAT";
export const CHANGE_EXVARNAME = "CHANGE_EXVARNAME";
export const CHANGE_EXVARNAMEOPT = "CHANGE_EXVARNAMEOPT";

//GM-WELL井戸入力パラメータ
export const CHANGE_ANALYRADIUS = "CHANGE_ANALYRADIUS";
export const CHANGE_ANALYBHHEIGHT = "CHANGE_ANALYBHHEIGHT";
export const CHANGE_ANALYPUMP = "CHANGE_ANALYPUMP";
export const CHANGE_ANALYWL = "CHANGE_ANALYWL";
export const CHANGE_MESHRADIUS = "CHANGE_MESHRADIUS";
export const CHANGE_MESHVERTEX = "CHANGE_MESHVERTEX";
export const CHANGE_MESHSPLIT = "CHANGE_MESHSPLIT";
export const CHANGE_MESHZSPLIT = "CHANGE_MESHZSPLIT";
export const CHANGE_MESHBIAS = "CHANGE_MESHBIAS";
export const CHANGE_ANALYTARGET = "CHANGE_ANALYTARGET";
export const CHANGE_POMPAMOUNT = "CHANGE_POMPAMOUNT";
export const CHANGE_WLDAMOUNT = "CHANGE_WLDAMOUNT";
export const CHANGE_MODELKIND = "CHANGE_MODELKIND";
export const ADD_POMPTR = "ADD_POMPTR";
export const ADD_SCREENTR = "ADD_WLTR";
export const DEL_POMPTR = "DEL_POMPTR";
export const DEL_SCREENTR = "DEL_WLTR";
export const UPDATE_POMPTR = "UPDATE_POMPTR";
export const CHANGE_POMPTRSELROW = "CHANGE_POMPTRSELROW";
export const CHANGE_SCREENZSPLIT = "CHANGE_SCREENZSPLIT";
export const CHANGE_MAPMESHLAY = "CHANGE_MAPMESHLAY";
export const CHANGE_EQUPERMCHECK = "CHANGE_EQUPERMCHECK";
export const CHANGE_PROBTHRESHOLD = "CHANGE_PROBTHRESHOLD";
export const CHANGE_CROSSVALID = "CHANGE_CROSSVALID";
export const ADD_WELLSTR = "ADD_WELLSTR";
export const UPDATE_WELLS_TR_DATA = "UPDATE_WELLS_TR_DATA";
export const CHANGE_ESTDS = "CHANGE_ESTDS";
export const CHANGE_WSAR = "CHANGE_WSAR";
export const CHANGE_INITNUM = "CHANGE_INITNUM";
export const CHANGE_WSSELROW = "CHANGE_WSSELROW";
export const CHANGE_PREWL = "CHANGE_PREWL";
export const CHANGE_SAME_DEPTH = "CHANGE_SAME_DEPTH";
export const CHANGE_BORING_SCORE = "CHANGE_BORING_SCORE";
export const CHANGE_AUTOSCRCHK = "CHANGE_AUTOSCRCHK";
export const CHANGE_CONSIDERMAT = "CHANGE_CONSIDERMAT";
export const CHANGE_BUDGET = "CHANGE_BUDGET";
export const CHANGE_UNITCOST = "CHANGE_UNITCOST";
export const CHANGE_MAXSCRNUM = "CHANGE_MAXSCRNUM";
export const CHANGE_ANALYSISTYPE = "CHANGE_ANALYSISTYPE";
export const CHANGE_OPTWS = "CHANGE_OPTWS";
export const CHANGE_CHKK = "CHANGE_CHKK";
export const CHANGE_CHKC = "CHANGE_CHKC";
export const CHANGE_TMPLAT = "CHANGE_TMPLAT";
export const CHANGE_TMPLON = "CHANGE_TMPLON";
export const CHANGE_TMPGL = "CHANGE_TMPGL";
export const CHANGE_TMPWL = "CHANGE_TMPWL";
export const UPDATE_TMPUSERDATA = "UPDATE_TMPUSERDATA";
export const CHANGE_CHECKPREIND = "CHANGE_CHECKPREIND";
export const CHANGE_ITSELROW = "CHANGE_ITSELROW";
export const CHANGE_INITTEMP = "CHANGE_INITTEMP";
export const CHANGE_CPLAT = "CHANGE_CPLAT";
export const CHANGE_CPLON = "CHANGE_CPLON";

export function finBoringLoadAction(isFin) {
  return {
    type: FIN_BORINGLOAD,
    isFin: isFin,
  };
}

export function changeRegNumAction(value) {
  return {
    type: CHANGE_REGNUM,
    value: value,
  };
}

export function addDsAction(data) {
  return {
    type: ADD_DS,
    data: data,
  };
}

export function changeDsAction(data) {
  return {
    type: CHANGE_DS,
    data: data,
  };
}

export function changeAllDsAction(data) {
  return {
    type: CHANGE_ALLDS,
    data: data,
  };
}

export function changeBorDsAction(data) {
  return {
    type: CHANGE_BORDS,
    data: data,
  };
}

export function delDsAction(rowID) {
  return {
    type: DEL_DS,
    rowID: rowID,
  };
}

export function changeSelRowAction(rowID) {
  return {
    type: CHANGE_SELROW,
    rowID: rowID,
  };
}

export function isDelAction(isDel) {
  return {
    type: ISDEL,
    isDel: isDel,
  };
}

export function changeListCatAction(value) {
  return {
    type: CHANGE_LISTCAT,
    value: value,
  };
}

export function changeShowChkAction(value, data) {
  return {
    type: CHANGE_SHOWCHK,
    value: value,
    data: data,
  };
}

export function changeUseChkAction(value, data) {
  return {
    type: CHANGE_USECHK,
    value: value,
    data: data,
  };
}

export function addCatAction(ID) {
  return {
    type: ADD_CAT,
    ID: ID,
  };
}

export function delCatAction(rowID) {
  return {
    type: DEL_CAT,
    rowID: rowID,
  };
}

export function changeCatNameAction(data) {
  return {
    type: CHANGE_CATNAME,
    data: data,
  };
}

export function changeCatSelRowAction(rowID) {
  return {
    type: CHANGE_CATSELROW,
    rowID: rowID,
  };
}

export function changeNameAction(name) {
  return {
    type: CHANGE_NAME,
    name: name,
  };
}

export function changeCatAction(cat) {
  return {
    type: CHANGE_CAT,
    cat: cat,
  };
}

export function changeGeoInfoAction(value) {
  return {
    type: CHANGE_GEOINFO,
    value: value,
  };
}

export function changeCoordSystemAction(coordSystem) {
  return {
    type: CHANGE_COORDSYSTEM,
    coordSystem: coordSystem,
  };
}

export function changeColorAction(color) {
  return {
    type: CHANGE_COLOR,
    color: color,
  };
}

export function changeTabAction(tab) {
  return {
    type: CHANGE_TAB,
    tab: tab,
  };
}

export function isOkAction(isOk) {
  return {
    type: ISOK,
    isOk: isOk,
  };
}

export function isDrawAction(isDraw) {
  return {
    type: ISDRAW,
    isDraw: isDraw,
  };
}

export function changeFileAction(file) {
  return {
    type: CHANGE_FILE,
    file: file,
  };
}

export function changeXAttrAction(value) {
  return {
    type: CHANGE_XATTR,
    value: value,
  };
}

export function changeYAttrAction(value) {
  return {
    type: CHANGE_YATTR,
    value: value,
  };
}

export function changeDepThkRdoAction(value) {
  return {
    type: CHANGE_DEPTHKRDO,
    value: value,
  };
}

export function changeZAttrAction(value) {
  return {
    type: CHANGE_ZATTR,
    value: value,
  };
}

export function changeGeoAction(value) {
  return {
    type: CHANGE_GEO,
    value: value,
  };
}

export function changeIDAction(value) {
  return {
    type: CHANGE_ID,
    value: value,
  };
}

export function changeGLChkAction(checked) {
  return {
    type: CHANGE_GLCHK,
    checked: checked,
  };
}

export function changeGLAction(value) {
  return {
    type: CHANGE_GL,
    value: value,
  };
}

export function changeWLChkAction(checked) {
  return {
    type: CHANGE_WLCHK,
    checked: checked,
  };
}

export function changeWLAction(value) {
  return {
    type: CHANGE_WL,
    value: value,
  };
}

export function changeHeaderNumAction(value) {
  return {
    type: CHANGE_HEADERNUM,
    value: value,
  };
}

export function changeFieldNameChkAction(checked) {
  return {
    type: CHANGE_FIELDNAMECHK,
    checked: checked,
  };
}

export function changeCsvDataAction(csvData) {
  return {
    type: CHANGE_CSVDATA,
    csvData: csvData,
  };
}

export function changeNewDataAction(newData) {
  return {
    type: CHANGE_NEWDATA,
    newData: newData,
  };
}

export function changeFormDataAction(formData) {
  return {
    type: CHANGE_FORMDATA,
    formData: formData,
  };
}

export function changeUserDataAction(data) {
  return {
    type: CHANGE_USERBORINGDATA,
    data: data,
  };
}

export function addPointAction(index) {
  return {
    type: ADD_POINT,
    index: index,
  };
}

export function delPointAction(rowID) {
  return {
    type: DEL_POINT,
    rowID: rowID,
  };
}

export function changeSelRowPAction(rowID) {
  return {
    type: CHANGE_SELROWP,
    rowID: rowID,
  };
}

export function isDelPAction(isDel) {
  return {
    type: IS_DELP,
    isDel: isDel,
  };
}

export function changeFieldAction(data) {
  return {
    type: CHANGE_FIELD,
    data: data,
  };
}

export function changeNewDsAction(data) {
  return {
    type: CHANGE_NEWDS,
    data: data,
  };
}

export function addLastGeoAction(ID1, ID2) {
  return {
    type: ADD_LASTGEO,
    ID1: ID1,
    ID2: ID2,
  };
}

export function changeBColorAction(value) {
  return {
    type: CHANGE_BCOLOR,
    value: value,
  };
}

export function changeExVarCatAction(value) {
  return {
    type: CHANGE_EXVARCAT,
    value: value,
  };
}

export function changeExVarNameAction(value) {
  return {
    type: CHANGE_EXVARNAME,
    value: value,
  };
}

export function changeExVarNameOptAction(opt) {
  return {
    type: CHANGE_EXVARNAMEOPT,
    opt: opt,
  };
}

export function changeAnalyRadiusAction(value) {
  return {
    type: CHANGE_ANALYRADIUS,
    value: value,
  };
}

export function changeAnalyBHHeightAction(value) {
  return {
    type: CHANGE_ANALYBHHEIGHT,
    value: value,
  };
}

export function changeAnalyPumpAction(value) {
  return {
    type: CHANGE_ANALYPUMP,
    value: value,
  };
}

export function changeAnalyWLAction(value) {
  return {
    type: CHANGE_ANALYWL,
    value: value,
  };
}

export function changeMeshRadiusAction(value) {
  return {
    type: CHANGE_MESHRADIUS,
    value: value,
  };
}

export function changeMeshVertexAction(value) {
  return {
    type: CHANGE_MESHVERTEX,
    value: value,
  };
}

export function changeMeshSplitAction(value) {
  return {
    type: CHANGE_MESHSPLIT,
    value: value,
  };
}

export function changeMeshZSplitAction(value) {
  return {
    type: CHANGE_MESHZSPLIT,
    value: value,
  };
}

export function changeMeshBiasAction(value) {
  return {
    type: CHANGE_MESHBIAS,
    value: value,
  };
}

export function changeAnalyTargetAction(value) {
  return {
    type: CHANGE_ANALYTARGET,
    value: value,
  };
}

export function changePompAmountAction(value) {
  return {
    type: CHANGE_POMPAMOUNT,
    value: value,
  };
}
export function changeWLDAmountAction(value) {
  return {
    type: CHANGE_WLDAMOUNT,
    value: value,
  };
}
export function changeModelKindAction(value) {
  return {
    type: CHANGE_MODELKIND,
    value: value,
  };
}
export function addPompTrAction(ID, TIME, WL, POMP) {
  return {
    type: ADD_POMPTR,
    TIME: TIME,
    WL: WL,
    POMP: POMP,
  };
}
export function delPompTrAction(rowID) {
  return {
    type: DEL_POMPTR,
    rowID: rowID,
  };
}

export function updatePompTrAction(value) {
  return {
    type: UPDATE_POMPTR,
    value: value,
  };
}

export function addScreenTrAction(ID, TOP, BOTTOM) {
  return {
    type: ADD_SCREENTR,
    ID: ID,
    TOP: TOP,
    BOTTOM: BOTTOM,
  };
}

export function delScreenTrAction(rowID) {
  return {
    type: DEL_SCREENTR,
    rowID: rowID,
  };
}
export function changeScreenZSplitAction(value) {
  return {
    type: CHANGE_SCREENZSPLIT,
    value: value,
  };
}
export function changeMapMeshLayAction(value) {
  return {
    type: CHANGE_MAPMESHLAY,
    value: value,
  };
}
export function changeEquPermCheckAction(value) {
  return {
    type: CHANGE_EQUPERMCHECK,
    value: value,
  };
}
export function changeProbThresholdAction(value) {
  return {
    type: CHANGE_PROBTHRESHOLD,
    value: value,
  };
}
export function changeCrossValidAction(value) {
  return {
    type: CHANGE_CROSSVALID,
    value: value,
  };
}

export function addWellsTrAction(ID, LAT, LON, KIND, PA, IT, PREDATA) {
  return {
    type: ADD_WELLSTR,
    ID: ID,
    LAT: LAT,
    LON: LON,
    KIND: KIND,
    PA: PA,
    IT: IT,
    PREDATA: PREDATA,
  };
}

export function updateWellsTrAction(value) {
  return {
    type: UPDATE_WELLS_TR_DATA,
    value: value,
  };
}

export function changeEewDsAction(data) {
  return {
    type: CHANGE_ESTDS,
    data: data,
  };
}

export function changeWsArAction(value) {
  return {
    type: CHANGE_WSAR,
    value: value,
  };
}

export function changeInitNumAction(value) {
  return {
    type: CHANGE_INITNUM,
    value: value,
  };
}

export function changePompTrSelRowAction(rowID) {
  return {
    type: CHANGE_POMPTRSELROW,
    rowID: rowID,
  };
}

export function changeWsSelRowAction(rowID) {
  return {
    type: CHANGE_WSSELROW,
    rowID: rowID,
  };
}

export function changePreWLAction(value) {
  return {
    type: CHANGE_PREWL,
    value: value,
  };
}

export function changeSameDepthAction(value) {
  return {
    type: CHANGE_SAME_DEPTH,
    value: value,
  };
}

export function changeBoringScoreAction(value) {
  return {
    type: CHANGE_BORING_SCORE,
    value: value,
  };
}

export function changeAutoScrChkAction(value) {
  return {
    type: CHANGE_AUTOSCRCHK,
    value: value,
  };
}

export function changeConsiderMatAction(value) {
  return {
    type: CHANGE_CONSIDERMAT,
    value: value,
  };
}

export function changeBudgetAction(value) {
  return {
    type: CHANGE_BUDGET,
    value: value,
  };
}

export function changeUnitCostAction(value) {
  return {
    type: CHANGE_UNITCOST,
    value: value,
  };
}

export function changeMaxScrNumAction(value) {
  return {
    type: CHANGE_MAXSCRNUM,
    value: value,
  };
}

export function changeAnalysisTypeAction(value) {
  return {
    type: CHANGE_ANALYSISTYPE,
    value: value,
  };
}

export function changeOptWSAction(value) {
  return {
    type: CHANGE_OPTWS,
    value: value,
  };
}

export function changeChkKAction(value) {
  return {
    type: CHANGE_CHKK,
    value: value,
  };
}
export function changeChkCAction(value) {
  return {
    type: CHANGE_CHKC,
    value: value,
  };
}

export function changeTmpLatAction(value) {
  return {
    type: CHANGE_TMPLAT,
    value: value,
  };
}

export function changeTmpLonAction(value) {
  return {
    type: CHANGE_TMPLON,
    value: value,
  };
}

export function changeTmpGlAction(value) {
  return {
    type: CHANGE_TMPGL,
    value: value,
  };
}

export function changeTmpWlAction(value) {
  return {
    type: CHANGE_TMPWL,
    value: value,
  };
}

export function changeTmpUserDataAction(value) {
  return {
    type: UPDATE_TMPUSERDATA,
    value: value,
  };
}

export function changeCheckPreIndAction(value) {
  return {
    type: CHANGE_CHECKPREIND,
    value: value,
  };
}

export function changeITSelRowAction(rowID) {
  return {
    type: CHANGE_ITSELROW,
    rowID: rowID,
  };
}

export function changeInitTempAction(value) {
  return {
    type: CHANGE_INITTEMP,
    value: value,
  };
}

export function changeCpLatAction(value) {
  return {
    type: CHANGE_CPLAT,
    value: value,
  };
}

export function changeCpLonAction(value) {
  return {
    type: CHANGE_CPLON,
    value: value,
  };
}
